import { render, staticRenderFns } from "./ProspectAlerteUpdate.vue?vue&type=template&id=30b27cc5"
import script from "./ProspectAlerteUpdate.vue?vue&type=script&lang=ts"
export * from "./ProspectAlerteUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports